import { urlApi } from "../../utils/const";

export default {
  async deleteOne(data) {
    const res = await fetch(urlApi + "/Ones/Delete", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    });
    return res.json();
  },
};
